"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOrUpdate = createOrUpdate;
exports["default"] = void 0;

/**
 * @module ol/TileRange
 */

/**
 * A representation of a contiguous block of tiles.  A tile range is specified
 * by its min/max tile coordinates and is inclusive of coordinates.
 */
var TileRange =
/** @class */
function () {
  /**
   * @param {number} minX Minimum X.
   * @param {number} maxX Maximum X.
   * @param {number} minY Minimum Y.
   * @param {number} maxY Maximum Y.
   */
  function TileRange(minX, maxX, minY, maxY) {
    /**
     * @type {number}
     */
    this.minX = minX;
    /**
     * @type {number}
     */

    this.maxX = maxX;
    /**
     * @type {number}
     */

    this.minY = minY;
    /**
     * @type {number}
     */

    this.maxY = maxY;
  }
  /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {boolean} Contains tile coordinate.
   */


  TileRange.prototype.contains = function (tileCoord) {
    return this.containsXY(tileCoord[1], tileCoord[2]);
  };
  /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Contains.
   */


  TileRange.prototype.containsTileRange = function (tileRange) {
    return this.minX <= tileRange.minX && tileRange.maxX <= this.maxX && this.minY <= tileRange.minY && tileRange.maxY <= this.maxY;
  };
  /**
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @return {boolean} Contains coordinate.
   */


  TileRange.prototype.containsXY = function (x, y) {
    return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
  };
  /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Equals.
   */


  TileRange.prototype.equals = function (tileRange) {
    return this.minX == tileRange.minX && this.minY == tileRange.minY && this.maxX == tileRange.maxX && this.maxY == tileRange.maxY;
  };
  /**
   * @param {TileRange} tileRange Tile range.
   */


  TileRange.prototype.extend = function (tileRange) {
    if (tileRange.minX < this.minX) {
      this.minX = tileRange.minX;
    }

    if (tileRange.maxX > this.maxX) {
      this.maxX = tileRange.maxX;
    }

    if (tileRange.minY < this.minY) {
      this.minY = tileRange.minY;
    }

    if (tileRange.maxY > this.maxY) {
      this.maxY = tileRange.maxY;
    }
  };
  /**
   * @return {number} Height.
   */


  TileRange.prototype.getHeight = function () {
    return this.maxY - this.minY + 1;
  };
  /**
   * @return {import("./size.js").Size} Size.
   */


  TileRange.prototype.getSize = function () {
    return [this.getWidth(), this.getHeight()];
  };
  /**
   * @return {number} Width.
   */


  TileRange.prototype.getWidth = function () {
    return this.maxX - this.minX + 1;
  };
  /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Intersects.
   */


  TileRange.prototype.intersects = function (tileRange) {
    return this.minX <= tileRange.maxX && this.maxX >= tileRange.minX && this.minY <= tileRange.maxY && this.maxY >= tileRange.minY;
  };

  return TileRange;
}();
/**
 * @param {number} minX Minimum X.
 * @param {number} maxX Maximum X.
 * @param {number} minY Minimum Y.
 * @param {number} maxY Maximum Y.
 * @param {TileRange} [tileRange] TileRange.
 * @return {TileRange} Tile range.
 */


function createOrUpdate(minX, maxX, minY, maxY, tileRange) {
  if (tileRange !== undefined) {
    tileRange.minX = minX;
    tileRange.maxX = maxX;
    tileRange.minY = minY;
    tileRange.maxY = maxY;
    return tileRange;
  } else {
    return new TileRange(minX, maxX, minY, maxY);
  }
}

var _default = TileRange;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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